import ReactLoadingSkeleton from 'react-loading-skeleton';

import { classNames } from '~/utils/styles';

import type { KPISkeletonProps } from './';
import { KPIBreakdownSkeleton } from './KpiSkeletonComponents';

export const KPISkeleton = ({ count, withValuesLabel, breakdownItemsCount = 0, className }: KPISkeletonProps) => {
  const valueItems = Array.from({ length: count ?? 1 }, (_, i) => i);
  return (
    <div className={classNames('flex-1 bg-white px-6 py-4 leading-none', className)} data-testid="skeleton-kpi">
      <ReactLoadingSkeleton borderRadius={1} height={16} width={80} />

      <div className="flex gap-8">
        {valueItems.map((i) => (
          <div className="mt-2 flex flex-col gap-1" key={i}>
            <ReactLoadingSkeleton borderRadius={1} height={28} width={120} />
            {withValuesLabel && <ReactLoadingSkeleton borderRadius={1} height={12} width={78} />}
          </div>
        ))}
      </div>

      {!!breakdownItemsCount && <KPIBreakdownSkeleton breakdownItemsCount={breakdownItemsCount} />}
    </div>
  );
};
